import { Resource } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

import { UseGetAllPageSizeProps } from '../types';
import usePermittedQuery from '../usePermittedQuery';

export const GET_ALL_RESOURCES_KEY = 'get-all-resources';

export const useGetAllResources = ({ page = 0, size = 10 }: UseGetAllPageSizeProps) => {
  return usePermittedQuery<Resource[]>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/resource?page=${page}&size=${size}`,
    {},
    [GET_ALL_RESOURCES_KEY],
    {
      enabled: typeof page === 'number' && page >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
